import React, { Fragment, useState, useContext } from "react";
import { Redirect } from "react-router-dom";

import Header from "../components/Header";
import { UrlServicesContext } from "../components/UrlServicesContext";

import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/Input";
import IconButton from "@material-ui/core/IconButton";
import {
  Visibility,
  VisibilityOff,
  KeyboardReturn,
  MoreVert,
} from "@material-ui/icons";
import FormControl from "@material-ui/core/FormControl";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import Slide from "@material-ui/core/Slide";
import { Animated } from "react-animated-css";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import axios from "axios";

const useStyles = makeStyles((theme) => ({
  container: {
    borderRadius: "5px",
    marginTop: "6%",
    backgroundColor: "#FFFFFF",
    height: "auto",
    border: "1px solid #CCCCCC",
    boxShadow:
      "0 4px 20px 0 rgba(0, 0, 0,.14), 0 7px 10px -5px rgba(0, 0, 0,.14)",
    width: "90%",
    paddingLeft: "0 !important",
    paddingRight: "0 !important",
  },
  imgLogo: {
    backgroundImage: "url(../../images/logo-ccq-contigo.png)",
    height: "60px",
    backgroundRepeat: "no-repeat",
    backgroundSize: "130px 40px",
    backgroundPosition: "center",
  },
  imgLogin: {
    backgroundImage: "url(../../images/login.png)",
    height: "150px",
    backgroundRepeat: "no-repeat",
    backgroundSize: "150px 150px",
    backgroundPosition: "center",
  },
  textField: {
    width: "90%",
    marginTop: "50px",
  },
  buttonSubmit: {
    fontFamily: '"Yanone Kaffeesatz", Sans-serif',
    letterSpacing: "1.5px",
    fontWeight: "600",
    marginTop: "6%",
    color: "#000",
    background: "#F7F00B",
    boxShadow:
      "0 4px 20px 0 rgba(0, 0, 0,.14), 0 7px 10px -5px rgba(0, 0, 0,.4)",
    "&:hover": {
      backgroundColor: "#000",
      color: "#F7F00B",
    },
  },
  textBotom: {
    padding: "10px",
    fontFamily: '"Yanone Kaffeesatz", Sans-serif',
    letterSpacing: "1.5px",
    fontWeight: "600",
    textDecoration: "none",
    color: "#000",
    cursor: "pointer",
  },
}));

const ColorLinearProgress = withStyles({
  colorPrimary: {
    backgroundColor: "#F7F00B",
  },
  barColorPrimary: {
    backgroundColor: "#000000",
  },
})(LinearProgress);

export default function Login() {
  const classes = useStyles();
  const [ver, setVer] = useState(true);
  const [loaderLogin, setLoaderLogin] = useState(false);
  const [nuevaClave, setNuevaClave] = useState(false);
  const [nuevoCorreo, setNuevoCorreo] = useState(false);
  const [inicio, setInicio] = useState(false);
  const [nuevaClaveCondicion, setNuevaClaveCondicion] = useState(false);

  const { urlServices, urlImgServicesDespachador } = useContext(
    UrlServicesContext
  );

  const [values, setValues] = useState({
    cedula: "",
    password: "",
    newPassword: "",
    showPassword: false,
    nombres: "",
    newEmail: "",
  });

  const [alert, setAlert] = useState({
    openAlert: false,
    mensaje_error: "",
    loggedIn: localStorage.getItem("token") == null ? false : true,
  });

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const verOn = (val) => (event) => {
    event.preventDefault();
    setLoaderLogin(true);

    if (val === 1) {
      if (values.cedula.length === 0) {
        setLoaderLogin(false);

        setAlert({
          ...alert,
          openAlert: true,
          mensaje_error: "Campo Cédula es requerido.",
        });
      } else {
        action();
      }
    } else if (val === 2) {
      if (values.newPassword.length === 0) {
        setLoaderLogin(false);
        setAlert({
          ...alert,
          openAlert: true,
          mensaje_error: "Campo Nueva contraseña es requerido.",
        });
      } else {
        action();
      }
    } else if (val === 3) {
      if (values.password.length === 0) {
        setLoaderLogin(false);
        setAlert({
          ...alert,
          openAlert: true,
          mensaje_error: "Campo Contraseña es requerido.",
        });
      } else {
        action();
      }
    } else if (val === 4) {
      if (values.newEmail.length === 0) {
        setLoaderLogin(false);
        setAlert({
          ...alert,
          openAlert: true,
          mensaje_error: "Campo correo electrónico es requerido.",
        });
      } else {
        action();
      }
    }
  };

  const action = () => {
    const data = new FormData();
    data.append("cedula", values.cedula.toLowerCase());
    data.append("newPassword", values.newPassword);
    data.append("email", values.newEmail.toLowerCase());
    data.append("password", values.password);

    axios
      .post(
        urlServices + "routes.php?servicio=validarUserDelivery",
        data
        /*{
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
      }*/
      )
      .then(
        (response) => {
          if (response.data.code === 0) {
            setTimeout(() => {
              localStorage.setItem("token", "9874563210");
              localStorage.setItem("user_name", response.data.nombres);
              localStorage.setItem(
                "user_fullname",
                response.data.nombresApellidos
              );
              localStorage.setItem("user_id", response.data.id);
              localStorage.setItem("perfil", response.data.perfil);
              if (
                response.data.avatar === "" ||
                response.data.avatar === null
              ) {
                localStorage.setItem(
                  "avatarUser",
                  '<img src="../../images/Deafult-Profile-Pitcher.png?v=' +
                    response.data.random +
                    "></img>"
                );
              } else {
                localStorage.setItem(
                  "avatarUser",
                  urlImgServicesDespachador +
                    response.data.avatar +
                    "?v=" +
                    response.data.random
                );
              }

              setAlert({ ...alert, loggedIn: true });
            }, 1500);
          } else if (response.data.code === 2) {
            setTimeout(() => {
              setNuevoCorreo(false);
              setLoaderLogin(false);
              setNuevaClave(true);

              if (response.data.condicion === 2) {
                setNuevaClaveCondicion(true);
              }
            }, 2000);
          } else if (response.data.code === 6) {
            setLoaderLogin(false);
            setVer(true);
            setAlert({
              ...alert,
              openAlert: true,
              mensaje_error: "Error al registrar, por favor vuelva a intentar.",
            });
          } else if (response.data.code === 4) {
            setTimeout(() => {
              setLoaderLogin(false);
              setVer(false);
              setNuevaClave(false);
              setValues({ ...values, newPassword: "" });
            }, 2000);
          } else if (response.data.code === 3) {
            setTimeout(() => {
              setLoaderLogin(false);
              setVer(true);
              setValues({ ...values, password: "" });
              setAlert({
                ...alert,
                openAlert: true,
                mensaje_error: "Contraseña incorrecta.",
              });
            }, 2000);
          } else if (response.data.code === 7) {
            setTimeout(() => {
              setLoaderLogin(false);
              setNuevoCorreo(true);
            }, 2000);
          } else {
            setTimeout(() => {
              setLoaderLogin(false);
              setVer(true);
              setAlert({
                ...alert,
                openAlert: true,
                mensaje_error: "Ingrese una cédula o correo registrado.",
              });
            }, 2000);
          }
        },
        (error) => {
          setTimeout(() => {
            setLoaderLogin(false);
            setAlert({
              ...alert,
              openAlert: true,
              mensaje_error: "Error de conexión, intente más tarde.",
            });
          }, 500);
        }
      );
  };

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ openAlert: false });
  };

  const handleInicio = () => {
    setInicio(true);
  };

  if (inicio) {
    return <Redirect to="/" />;
  }

  if (alert.loggedIn) {
    return <Redirect to="/dashboard" />;
  }

  return (
    <Fragment>
      <Header />

      <Container maxWidth="sm" className={classes.container}>
        {loaderLogin ? <ColorLinearProgress /> : ""}

        <div style={{ padding: "50px 10px 30px 10px", overflow: "hidden" }}>
          {ver && !nuevaClave && !nuevoCorreo ? (
            <Animated
              animationIn="fadeIn"
              animationInDuration={1000}
              isVisible={true}
            >
              <Grid
                container
                spacing={1}
                style={loaderLogin ? { opacity: "0.4" } : null}
              >
                <Grid item xs={12} sm={6}>
                  <center>
                    <img
                      src="../../images/undraw_web_developer_p3e5.png"
                      alt="Ciudades"
                      style={{
                        width: "250px",
                        height: "160px",
                        objectFit: "cover",
                      }}
                    />
                  </center>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormControl className={classes.textField}>
                    <TextField
                      autoComplete="off"
                      name="cedula"
                      value={values.cedula}
                      onChange={handleChange("cedula")}
                      inputProps={{ maxLength: 255 }}
                      label="Cédula o Correo electrónico"
                      //helperText="Error"
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <center>
                    <Button
                      className={classes.buttonSubmit}
                      onClick={verOn(1)}
                      variant="contained"
                      color="primary"
                      size="large"
                    >
                      Validar
                    </Button>
                  </center>
                </Grid>
              </Grid>
            </Animated>
          ) : !nuevaClave && !nuevoCorreo ? (
            <div>
              <Animated
                animationIn="slideInLeft"
                animationInDuration={500}
                isVisible={true}
              >
                <Grid
                  container
                  spacing={1}
                  style={loaderLogin ? { opacity: "0.4" } : null}
                >
                  <Grid item xs={12} sm={6}>
                    <img
                      src="../../images/undraw_fingerprint_swrc.png"
                      alt="Ciudades"
                      style={{
                        width: "210px",
                        height: "160px",
                        objectFit: "cover",
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant="subtitle1"
                      className={classes.textBotom}
                    >
                      {" "}
                      Te damos la bienvenida
                    </Typography>
                    <FormControl className={classes.textField}>
                      <InputLabel htmlFor="standard-adornment-password">
                        Contraseña
                      </InputLabel>
                      <Input
                        type={values.showPassword ? "text" : "password"}
                        value={values.password}
                        onChange={handleChange("password")}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {values.showPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </Animated>

              <center>
                <Button
                  className={classes.buttonSubmit}
                  variant="contained"
                  onClick={verOn(3)}
                  color="primary"
                  size="large"
                >
                  Iniciar sesión
                </Button>
              </center>
            </div>
          ) : (
            ""
          )}

          {nuevoCorreo ? (
            <Animated
              animationIn="slideInLeft"
              animationInDuration={500}
              isVisible={true}
            >
              <Grid
                container
                spacing={1}
                style={loaderLogin ? { opacity: "0.4" } : null}
              >
                <Grid item xs={12} sm={6}>
                  <center>
                    <img
                      src="../../images/undraw_message_sent_1030.png"
                      alt="Ciudades"
                      style={{
                        width: "250px",
                        height: "160px",
                        objectFit: "cover",
                      }}
                    />
                  </center>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle1" className={classes.textBotom}>
                    {" "}
                    Paso - 1 de 2
                  </Typography>
                  <FormControl className={classes.textField}>
                    <TextField
                      autoComplete="off"
                      name="newEmail"
                      value={values.newEmail}
                      onChange={handleChange("newEmail")}
                      inputProps={{ maxLength: 255 }}
                      label="Correo electrónico"
                      //helperText="Error"
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <center>
                    <Button
                      className={classes.buttonSubmit}
                      onClick={verOn(4)}
                      variant="contained"
                      color="primary"
                      size="large"
                    >
                      Registrar
                    </Button>
                  </center>
                </Grid>
              </Grid>
            </Animated>
          ) : (
            ""
          )}

          {nuevaClave ? (
            <Animated
              animationIn="slideInLeft"
              animationInDuration={500}
              isVisible={true}
            >
              <Grid
                container
                spacing={1}
                style={loaderLogin ? { opacity: "0.4" } : null}
              >
                <Grid item xs={12} sm={6}>
                  <center>
                    <img
                      src="../../images/undraw_prioritise_tgdh.png"
                      alt="Ciudades"
                      style={{
                        width: "210px",
                        height: "160px",
                        objectFit: "cover",
                      }}
                    />
                  </center>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle1" className={classes.textBotom}>
                    {!nuevaClaveCondicion ? " Paso - 2 de 2" : ""}
                  </Typography>
                  <FormControl className={classes.textField}>
                    <InputLabel htmlFor="standard-adornment-password">
                      Nueva contraseña
                    </InputLabel>
                    <Input
                      type={values.showPassword ? "text" : "password"}
                      value={values.newPassword}
                      onChange={handleChange("newPassword")}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                          >
                            {values.showPassword ? (
                              <Visibility />
                            ) : (
                              <VisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <center>
                    <Button
                      className={classes.buttonSubmit}
                      onClick={verOn(2)}
                      variant="contained"
                      color="primary"
                      size="large"
                    >
                      Registrar
                    </Button>
                  </center>
                </Grid>
              </Grid>
            </Animated>
          ) : (
            ""
          )}
        </div>
      </Container>

      <Grid container>
        <Grid item xs={12} sm={12} style={{ marginTop: "50px" }}>
          <Typography
            variant="subtitle1"
            style={{ fontWeight: "bold" }}
            align="center"
          >
            <span
              style={{
                top: "-.4em",
                position: "relative",
                verticalAlign: "baseline",
              }}
            >
              <a className={classes.textBotom} href="#" onClick={handleInicio}>
                <KeyboardReturn style={{ verticalAlign: "middle" }} /> Inicio
              </a>
            </span>{" "}
            <MoreVert />{" "}
            <span
              style={{
                top: "-.4em",
                position: "relative",
                verticalAlign: "baseline",
              }}
            >
              <a
                className={classes.textBotom}
                target="_blank"
                href="https://delivery.goubi.com.ec/"
              >
                Registrarme
              </a>
            </span>
          </Typography>
        </Grid>
      </Grid>

      {alert.openAlert ? (
        <Snackbar
          open={true}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={handleCloseAlert}
        >
          <Slide direction="up" in={true} mountOnEnter unmountOnExit>
            <Alert
              onClose={handleCloseAlert}
              severity="error"
              elevation={6}
              variant="filled"
            >
              {alert.mensaje_error}
            </Alert>
          </Slide>
        </Snackbar>
      ) : (
        ""
      )}
    </Fragment>
  );
}
